import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import Iconify from '../../../components/Iconify';
import Label from '../../../components/Label';
import { stripeSubscriptionUrl } from '../../../helpers/subscriptions';

// Mapea el status de Stripe a un color del Label.
const STATUS_COLOR = {
  unpaid: 'error',
  past_due: 'error',
  incomplete: 'warning',
  incomplete_expired: 'default',
  trialing: 'info',
  paused: 'default',
};

const groupByStatus = (items) => {
  const groups = {};
  (items || []).forEach((it) => {
    const k = it.status || 'unknown';
    if (!groups[k]) groups[k] = [];
    groups[k].push(it);
  });
  return groups;
};

export default function AnomaliesSection({ items }) {
  const visibleItems = (items || []).filter((it) => it.status !== 'expired');
  const groups = groupByStatus(visibleItems);
  const statuses = Object.keys(groups).sort();
  const total = visibleItems.length;

  return (
    <Card>
      <CardHeader title="Anomalías" subheader={`${total} suscripción${total === 1 ? '' : 'es'} en estado no activo`} />
      {total === 0 ? (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Todas las suscripciones están activas.
          </Typography>
        </Box>
      ) : (
        <Stack spacing={3} sx={{ p: 3, pt: 1 }}>
          {statuses.map((status) => (
            <Box key={status}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Label color={STATUS_COLOR[status] || 'default'}>{status}</Label>
                <Typography variant="caption" color="text.secondary">
                  {groups[status].length}
                </Typography>
              </Stack>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Fuente</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Producto</TableCell>
                      <TableCell>Moneda</TableCell>
                      <TableCell align="right" />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groups[status].map((r) => (
                      <TableRow key={r.id} hover>
                        <TableCell>
                          <Label color={r.source === 'manual' ? 'default' : 'info'}>{r.source || 'stripe'}</Label>
                        </TableCell>
                        <TableCell>{r.customerEmail || '—'}</TableCell>
                        <TableCell>{r.productName || '—'}</TableCell>
                        <TableCell>{r.currency?.toUpperCase() || '—'}</TableCell>
                        <TableCell align="right">
                          {r.source === 'manual' ? null : (
                            <Tooltip title="Ver en Stripe">
                              <IconButton
                                size="small"
                                component="a"
                                href={stripeSubscriptionUrl(r.id)}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <Iconify icon="eva:external-link-outline" width={18} height={18} />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
        </Stack>
      )}
    </Card>
  );
}

AnomaliesSection.propTypes = {
  items: PropTypes.array,
};
